<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "PayableRateIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
